import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Download, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { generateReceiptPDF } from "@/lib/receipt";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default function BookingView() {
  const { id } = useParams();
  const [booking, setBooking] = useState(undefined);

  useEffect(() => {
    api.get(`/bookings/${id}`).then((r) => setBooking(r.data)).catch(() => setBooking(null));
  }, [id]);

  if (booking === undefined)
    return <div className="min-h-screen grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  if (booking === null)
    return (
      <div className="min-h-screen grid place-items-center px-6 text-center">
        <div>
          <p className="font-serif text-3xl text-primary">Booking not found</p>
          <Link to="/" className="mt-4 inline-block text-sm text-primary underline">Back to home</Link>
        </div>
      </div>
    );

  const b = booking;
  const row = (l, v) => (
    <div className="flex justify-between py-1.5 text-sm"><span className="text-muted-foreground">{l}</span><span className="text-right font-medium">{v}</span></div>
  );

  return (
    <div className="min-h-screen bg-secondary/30 py-8 px-5">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-primary mb-4"><ArrowLeft className="w-4 h-4" /> Home</Link>
        <div className="rounded-3xl bg-card border border-border p-6">
          <div className="text-center">
            <div className="mx-auto grid place-items-center w-14 h-14 rounded-full bg-primary/10 text-primary"><CheckCircle2 className="w-8 h-8" /></div>
            <h1 className="font-serif text-3xl text-primary mt-3">The Quisine</h1>
            <p className="text-sm text-muted-foreground">Booking {b.receipt_no}</p>
          </div>
          <div className="mt-5 border-t border-border pt-4">
            {row("Name", b.name)}
            {row("Mobile", b.phone)}
            {row("Address", `${b.address}, ${b.city}`)}
            {row("Persons", b.persons)}
            {row("Event", `${b.event_date} @ ${b.event_time}`)}
            {row("Preference", b.without_onion_garlic ? "Without Onion & Garlic" : "Regular")}
            {b.cooking_instructions ? row("Instructions", b.cooking_instructions) : null}
          </div>
          <div className="mt-4 border-t border-border pt-4">
            <p className="font-serif text-lg text-primary">Main Menu</p>
            <ul className="mt-2 space-y-1 text-sm">
              {(b.items || []).map((i, idx) => <li key={idx} className="text-foreground/80">• {i.dish}</li>)}
            </ul>
            <p className="font-serif text-lg text-primary mt-3">Complimentary</p>
            <p className="text-sm text-muted-foreground">{(b.custom_items || []).join(" · ")}</p>
          </div>
          <div className="mt-4 border-t border-border pt-4">
            {row("Total amount", inr(b.total_amount))}
            {row("Advance paid", inr(b.advance_paid))}
            <div className="flex justify-between py-1.5"><span className="font-serif text-lg text-primary">Balance due</span><span className="font-serif text-lg text-primary">{inr(b.balance_due)}</span></div>
          </div>
          <button data-testid="view-download-pdf" onClick={() => generateReceiptPDF(b)}
            className="mt-5 h-13 py-3.5 w-full rounded-full bg-primary text-primary-foreground font-medium grid place-items-center">
            <span className="flex items-center gap-2"><Download className="w-5 h-5" /> Download Receipt (PDF)</span>
          </button>
        </div>
      </div>
    </div>
  );
}
